import { SyncOutlined } from '@ant-design/icons';
import { Typography } from 'antd';
import { observer } from 'mobx-react-lite';
import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { SpacingUnit, SpacingRow } from 'components/ui';
import { ApprovalStatus, StatusType } from 'entities/TableCellActivity';

import { Wrapper } from '../Wrapper';
import { ActivityRendererProps } from '../types';

import s from './StatusChangeActivity.module.scss';

const StatusChangeActivity: React.FC<ActivityRendererProps> = ({
  entity,
  onDelete,
  onEdit,
}) => {
  const { t } = useTranslation();
  const statusChange = entity.statusChange;

  const STATUS_LABELS: Record<ApprovalStatus, string> = {
    wip: t('statusChange.wip'),
    done: t('statusChange.done'),
  };

  const STATUS_TYPE_LABELS: Record<StatusType, string> = {
    functional: t('statusChange.functional'),
    administrative: t('statusChange.administrative'),
  };

  if (!statusChange) {
    return null;
  }

  const prevLabel = STATUS_LABELS[statusChange.prevStatus];
  const currLabel = STATUS_LABELS[statusChange.currStatus];
  const typeLabel = STATUS_TYPE_LABELS[statusChange.statusType];

  return (
    <Wrapper
      onEdit={onEdit}
      onDelete={onDelete}
      icon={<SyncOutlined className={s.statusChangeActivity__activityIcon} />}
      entity={entity}
    >
      <div className={s.statusChangeActivity__activity}>
        <SpacingRow hSpacing={SpacingUnit.unit2}>
          <Typography.Text className={s.statusChangeActivity__label}>
            {typeLabel}:
          </Typography.Text>
          <Typography.Text className={s.statusChangeActivity__valuePrevious}>
            {prevLabel}
          </Typography.Text>
          <Typography.Text>→</Typography.Text>
          <Typography.Text className={s.statusChangeActivity__valueCurrent}>
            {currLabel}
          </Typography.Text>
        </SpacingRow>
        {!statusChange.isDirectChange && statusChange.triggeredByUserName && (
          <Typography.Text
            type="secondary"
            className={s.statusChangeActivity__cascade}
          >
            {t('statusChange.fromBranch', { userName: statusChange.triggeredByUserName })}
          </Typography.Text>
        )}
      </div>
    </Wrapper>
  );
};

export default observer(StatusChangeActivity);
